module.exports = __webpack_public_path__ + "static/full7-fb89fea29966fdc7f952269baa3fe1f9.png";